import Cookies from 'js-cookie'

import { isProduction } from 'utils/nodeEnv'

import { api } from './api'

export const loginUser = async (email: string, password: string, rememberMe?: boolean) => {
  try {
    const response = await api.login(email, password)
    if (!response.ok || !response.data) throw new Error(`bad response: ${response.problem}`)

    if (rememberMe) Cookies.set('token', response.data.token, { expires: 14 })
    else Cookies.set('token', response.data.token)

    api.api.setHeader('Authorization', `Bearer ${response.data.token}`)
    return response
  } catch (error) {
    if (!isProduction()) console.error(error)

    if (error instanceof Error) throw new Error(error.message)
  }
}

export const changePassword = async (
  userId: string,
  oldPassword: string,
  newPassword: string,
): Promise<number | undefined> => {
  try {
    const response = await api.changePassword(userId, oldPassword, newPassword)
    if (response.status === 403) return response.status

    if (!response.ok) throw new Error(`bad response: ${response.problem}`)

    return response.status
  } catch (err) {
    if (!isProduction()) console.error(err)
  }
}

export const requestResetPassword = async (email: string): Promise<{ message: string }> => {
  try {
    const response = await api.requestResetPassword(email)

    if (response?.data?.message) throw new Error(response.data.message)

    if (!response.ok || !response.status) throw new Error(`bad response: ${response.problem}`)

    return { message: 'success' }
  } catch (err) {
    return { message: (err as Error).message }
  }
}

export const resetPassword = async (
  token: string,
  password: string,
): Promise<number | undefined> => {
  try {
    const response = await api.resetPassword(token, password)
    if (!response.ok) throw new Error(`bad response: ${response.problem}`)

    return response.status
  } catch (err) {
    if (!isProduction()) console.error(err)
  }
}

export const updateLastLogin = async (userId: string) => {
  try {
    const response = await api.updateLastLogin(userId)
    if (!response.ok || !response.data) throw new Error(`bad response: ${response.problem}`)

    return response
  } catch (error) {
    return { error, ok: false }
  }
}
